import styles from "./AmountSection.module.css";
import currencyToSymbol from "../../../currencyMap";

export const AmountSection = ({
  amount,
  currency,
}: {
  amount: string | any;
  currency: any;
}) => {
  const formatDollar = (num: any) => {
    let p = num.split(".");
    return (
      p[0]
        .split("")
        .reverse()
        .reduce((acc: any, num: any, i: any, orig: any) => {
          return num + (num != "-" && i && !(i % 3) ? "," : "") + acc;
        }, "") +
      "." +
      p[1]
    );
  };
  return (
    <div className={styles.container}>
      <p className={styles.label}>Pay</p>
      <span className={styles.amount}>
        {currencyToSymbol[currency] || currency}
        {/* {Number(amount.toFixed(1)).toLocaleString()} */}
        {formatDollar(amount)}
        {/* {amount} */}
      </span>
    </div>
  );
};
